import useReveal from "@/hooks/useReveal";

export default function AboutPhilosophy() {
  const r = useReveal();
  return (
    <section ref={r} className="relative py-32 md:py-40">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-5">
          <div className="eyebrow mb-6">Our Philosophy</div>
          <h2 className="font-serif text-5xl md:text-6xl tracking-tight font-light leading-[1]">
            Travel is not <em className="italic text-indigo_deep">consumed.</em>
            <br />It is <em className="italic text-terracotta">received.</em>
          </h2>
        </div>
        <div className="col-span-12 md:col-span-6 md:col-start-7">
          <p className="dropcap text-lg leading-[1.85] text-ink/85 font-light">
            We believe travel is more than visiting new places — it is about
            connecting with cultures, traditions, and people in meaningful
            ways. Our experiences are designed to offer deep cultural
            immersion while maintaining the highest standards of comfort. Our
            clients return less as photographers and more as students; less as
            tourists, more as quiet guests.
          </p>
        </div>
      </div>
    </section>
  );
}
